import cn from "@/utils/cn"

type OpenInNewTabProps = {
  url: string
  onClick?: () => void
  className?: string
  stopPropagation?: boolean
}

/**
 * Renders an icon which, when clicked, opens the specified URL in a new browser tab.
 *
 * NOTE: The component stops propagation of the click event by default.
 *
 * @param {string} [url] - The URL to open in a new tab.
 * @param {function} [onClick] - Optional click handler that is called after opening the tab.
 * @param {string} [className] - Optional additional class names.
 * @param {boolean} [stopPropagation] - Whether to stop propagation of the click event.
 * @returns {JSX.Element} The rendered icon/component.
 *
 */
const OpenInNewTab = ({
  url,
  onClick,
  className,
  stopPropagation = true,
}: OpenInNewTabProps) => {
  return (
    <span
      className={cn("icon-hover material-icons text-icon-lg!", className)}
      onClick={(e) => {
        if (stopPropagation) {
          e.preventDefault()
          e.stopPropagation()
        }
        window.open(url, "_blank")
        onClick?.()
      }}
    >
      open_in_new
    </span>
  )
}

export default OpenInNewTab
